var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04167 7.16667H7.58083L7.4175 7.00917C7.98917 6.34417 8.33333 5.48083 8.33333 4.54167C8.33333 2.4475 6.63583 0.75 4.54167 0.75C2.4475 0.75 0.75 2.4475 0.75 4.54167C0.75 6.63583 2.4475 8.33333 4.54167 8.33333C5.48083 8.33333 6.34417 7.98917 7.00917 7.4175L7.16667 7.58083V8.04167L10.0833 10.9525L10.9525 10.0833L8.04167 7.16667V7.16667ZM4.54167 7.16667C3.08917 7.16667 1.91667 5.99417 1.91667 4.54167C1.91667 3.08917 3.08917 1.91667 4.54167 1.91667C5.99417 1.91667 7.16667 3.08917 7.16667 4.54167C7.16667 5.99417 5.99417 7.16667 4.54167 7.16667Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e96b186dbb1935d099b023dc627c66c8.svg";
export { ForwardRef as ReactComponent };